export const getOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "LAIMU",
  "alternateName": "LAIMU Trantor",
  "url": "https://laimu.mx",
  "logo": "https://laimu.mx/logo.png",
  "description": "Leading provider of integrated business management solutions including ERP, CRM, TMS, MRP, HRMS, and KPI systems for automotive, manufacturing, logistics, and printing industries.",
  "foundingDate": "2015",
  "slogan": "Transformando empresas con tecnología integral",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pedro Noriega 1751",
    "addressLocality": "Monterrey",
    "addressRegion": "NL",
    "postalCode": "64580",
    "addressCountry": "MX"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+52 81 11071450",
    "contactType": "customer service",
    "email": "info@laimu.mx",
    "availableLanguage": ["English", "Spanish"]
  },
  "sameAs": [
    "https://www.linkedin.com/company/laimu",
    "https://twitter.com/LaimuTrantor",
    "https://www.facebook.com/LaimuTrantor",
    "https://www.youtube.com/c/LaimuTrantor"
  ],
  "industry": "Software Development",
  "numberOfEmployees": "51-200",
  "areaServed": {
    "@type": "Country",
    "name": "Mexico"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Business Management Software Solutions",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "SoftwareApplication",
          "name": "ERP System",
          "description": "Enterprise Resource Planning system for comprehensive business management"
        }
      },
      {
        "@type": "Offer", 
        "itemOffered": {
          "@type": "SoftwareApplication",
          "name": "CRM System",
          "description": "Customer Relationship Management system for sales and customer service"
        }
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "127",
    "bestRating": "5",
    "worstRating": "1"
  },
  "priceRange": "$$"
});

export const getSoftwareApplicationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "LAIMU Trantor",
  "description": "Comprehensive business management platform integrating ERP, CRM, TMS, MRP, HRMS, and KPI systems",
  "url": "https://laimu.mx",
  "applicationCategory": "BusinessApplication",
  "applicationSubCategory": "Enterprise Resource Planning",
  "operatingSystem": "Web-based",
  "softwareVersion": "2024.1",
  "datePublished": "2015-01-01",
  "dateModified": "2024-01-15",
  "author": {
    "@type": "Organization",
    "name": "LAIMU"
  },
  "offers": {
    "@type": "Offer",
    "price": "Contact for pricing",
    "priceCurrency": "MXN",
    "availability": "https://schema.org/InStock",
    "validFrom": "2024-01-01"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "127",
    "bestRating": "5",
    "worstRating": "1"
  },
  "featureList": [
    "Enterprise Resource Planning (ERP)",
    "Customer Relationship Management (CRM)",
    "Transportation Management System (TMS)",
    "Manufacturing Resource Planning (MRP)",
    "Human Resource Management System (HRMS)",
    "Key Performance Indicators (KPI) Dashboard"
  ],
  "screenshot": "https://images.pexels.com/photos/8867431/pexels-photo-8867431.jpeg",
  "downloadUrl": "https://laimu.mx/demo",
  "installUrl": "https://laimu.mx/demo",
  "supportUrl": "https://laimu.mx/#contact"
});

export const getWebSiteStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "LAIMU Trantor",
  "url": "https://laimu.mx",
  "description": "Transform your business with LAIMU Trantor's comprehensive management platform",
  "inLanguage": ["es-MX", "en"],
  "isAccessibleForFree": true,
  "publisher": {
    "@type": "Organization",
    "name": "LAIMU"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://laimu.mx/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
});

export const getServiceStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Business Management Software Solutions",
  "description": "Comprehensive ERP, CRM, TMS, MRP, HRMS, and KPI solutions for businesses",
  "provider": {
    "@type": "Organization",
    "name": "LAIMU"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Mexico"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Business Software Solutions",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "ERP Implementation",
          "description": "Enterprise Resource Planning system implementation and customization"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "CRM Solutions",
          "description": "Customer Relationship Management system setup and optimization"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "TMS Integration",
          "description": "Transportation Management System for logistics optimization"
        }
      }
    ]
  }
});

export const getBreadcrumbStructuredData = (items: Array<{name: string, url: string}>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getFAQStructuredData = (faqs: Array<{question: string, answer: string}>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const getArticleStructuredData = (article: {
  title: string;
  description: string;
  author: string;
  datePublished: string;
  dateModified: string;
  image: string;
  url: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.description,
  "author": {
    "@type": "Person",
    "name": article.author
  },
  "publisher": {
    "@type": "Organization",
    "name": "LAIMU",
    "logo": {
      "@type": "ImageObject",
      "url": "https://laimu.mx/logo.png"
    }
  },
  "datePublished": article.datePublished,
  "dateModified": article.dateModified,
  "image": article.image,
  "url": article.url
});